
const common = {
  // Navigation
  brand_story: "Histoire de la marque",
  our_philosophy: "Notre philosophie", 
  product_series: "Gamme de produits",
  global_sourcing: "Approvisionnement mondial",
  start_journey: "Commencer le voyage",
  
  // Hero Section
  hero_title: "Récupérez votre droit à la",
  hero_title_highlight: "jeunesse",
  hero_description: "LunaKey fournit les superaliments les plus efficaces de la nature, scientifiquement conçus pour s'intégrer dans vos rituels quotidiens, vous permettant de rayonner d'éclat et de vitalité éternelle.",
  hero_cta: "Commencez votre voyage",
  
  // Story Section
  story_title: "Du mythe à la modernité",
  story_subtitle: "De la légende à la réalité",
  story_description_1: "Dans les légendes anciennes, la déesse Luna dansait avec le cerf spirituel sous la lumière de la lune, gardant les secrets de la nature et la vitalité de la vie. Cette puissance mythique se transforme maintenant en chaque produit LunaKey grâce à l'extraction précise de la science moderne.",
  story_description_2: "Nous adhérons à la philosophie 'La nature donne du pouvoir, la science confirme les droits', transformant les superaliments les plus précieux du monde en sources de vitalité pour votre vie quotidienne grâce à des processus scientifiques rigoureux.",
  story_quote: "Nous ne luttons pas contre le temps, mais reconstituons votre droit de vous sentir jeune dans le temps.",
  
  // Philosophy Section
  philosophy_title: "Notre philosophie",
  philosophy_subtitle: "Système de valeurs trinitaire, construisant votre mode de vie sain",
  natures_proof: "Preuve de la nature",
  natures_proof_subtitle: "Preuve de la nature",
  natures_proof_description: "Superaliments haute efficacité approvisionnés mondialement, zéro additif artificiel. Chaque produit porte la force la plus pure de la nature, ayant subi une sélection rigoureuse et une vérification scientifique.",
  empowered_confidence: "Confiance autonomisée",
  empowered_confidence_subtitle: "Confiance autonomisée",
  empowered_confidence_description: "Ressentez la sérénité et la tranquillité d'esprit qui viennent du contrôle de votre propre santé. Quand vous choisissez LunaKey, vous choisissez le meilleur investissement et soin pour vous-même.",
  your_vitality: "Votre vitalité, votre droit",
  your_vitality_subtitle: "Votre vitalité, votre droit",
  your_vitality_description: "Un manifeste sur les soins personnels proactifs et la souveraineté sanitaire. Vous avez le droit au meilleur état, le droit de ressentir la vitalité infinie de la vie.",
  
  // Products Section
  products_title: "Vos droits, reconstitués ici",
  products_subtitle: "Deux gammes de produits principales offrant un soutien complet pour votre santé et beauté",
  proof_series: "Série de preuves de droits",
  proof_series_subtitle: "Série de preuves de droits",
  proof_series_description: "Superaliments premium mondiaux sélectionnés, fournissant la preuve la plus forte pour votre santé. Chaque produit subit un contrôle qualité strict, garantissant la supplémentation nutritionnelle la plus pure.",
  declaration_series: "Série de déclarations énergétiques",
  declaration_series_subtitle: "Série de déclarations énergétiques",
  declaration_series_description: "Solutions de supplémentation énergétique conçues pour les modes de vie modernes, vous permettant de maintenir un état optimal dans la vie quotidienne trépidante, montrant l'éclat intérieur et la vitalité.",
  acai_powder: "Poudre d'açaï",
  acai_description: "Riche en antioxydants, renforce l'immunité",
  white_tomato: "Poudre de tomate blanche",
  white_tomato_description: "Blanchiment naturel, éclat de la peau",
  glow_booster: "Booster d'éclat",
  glow_description: "Cultivation intérieure et extérieure, éclat naturel",
  energy_elixir: "Élixir d'énergie",
  energy_description: "Énergie soutenue, libération du potentiel infini",
  learn_more: "En savoir plus",
  
  // Sourcing Section
  sourcing_title: "Suivant les traces du cerf",
  sourcing_subtitle: "Suivant les traces du cerf spirituel, explorant les origines des superaliments les plus précieux du monde",
  brazil: "Brésil",
  brazil_ingredient: "Baie d'açaï",
  brazil_description: "Joyaux violets des profondeurs de la forêt amazonienne, riches en anthocyanes et antioxydants, le code de jeunesse accordé par la nature.",
  peru: "Pérou",
  peru_ingredient: "Racine de maca",
  peru_description: "Source d'énergie des hauts plateaux andins, louée comme 'ginseng péruvien' depuis des millénaires, infusant le corps d'une vitalité durable.",
  himalaya: "Himalaya",
  himalaya_ingredient: "Baie de goji",
  himalaya_description: "Trésors rouges du toit du monde, cultivés dans un environnement polaire avec une force vitale super forte, médecine naturelle nourrissant le corps et l'esprit.",
  mediterranean: "Méditerranée",
  mediterranean_ingredient: "Feuille d'olivier",
  mediterranean_description: "Essence verte sous le soleil méditerranéen, portant la sagesse millénaire de la santé, apportant une protection pure à la vie moderne.",
  
  // Newsletter Section
  newsletter_title: "Recevez votre guide de renouvellement de vitalité",
  newsletter_description: "Abonnez-vous à notre contenu exclusif pour obtenir les dernières informations sur la santé, les mises à jour de produits et des conseils nutritionnels professionnels, commençant votre voyage de vitalité.",
  email_placeholder: "Votre adresse e-mail",
  subscribe: "S'abonner",
  subscribing: "Abonnement...",
  subscribe_success: "Abonnement réussi ! Merci de rejoindre la famille LunaKey.",
  subscribe_error: "Échec de l'abonnement, veuillez réessayer plus tard.",
  privacy_notice: "Nous promettons de protéger votre vie privée et ne partagerons pas vos informations avec des tiers. Vous pouvez vous désabonner à tout moment.",
  
  // Footer
  quality_assurance: "Assurance qualité",
  about_us: "À propos de nous",
  contact_us: "Nous contacter",
  careers: "Carrières",
  faq: "FAQ",
  user_guide: "Guide utilisateur",
  customer_service: "Service client", 
  return_policy: "Politique de retour",
  footer_description: "Récupérez votre droit à la jeunesse, laissez les superaliments les plus efficaces de la nature s'intégrer dans vos rituels quotidiens, rayonnant d'éclat et de vitalité éternelle.",
  all_rights_reserved: "Tous droits réservés",
  privacy_policy: "Politique de confidentialité",
  terms_of_service: "Conditions de service"
};

export default common;
